<template>
  <VView class="gallery-item" back-button-to="/gallery" :header="header">
    <transition name="fade" appear>
      <div v-if="entry">
        <VBlock class="gallery-item__photo" max-width="600px">
          <img :src="entry.result.attachment" />
        </VBlock>
      </div>
    </transition>
  </VView>
</template>

<script>
export default {
  name: 'GalleryItem',

  props: {
    entryId: {
      type: String,
      required: true,
    },
  },

  data: () => ({
    entry: null,
  }),

  computed: {
    header() {
      return this.entry ? `${this.entry.firstName} ${this.entry.lastName}` : 'Ładowanie...';
    },
  },

  async mounted() {
    const { data: entries } = await this.$bricodes.getPublicEntries();
    console.log(entries);
    this.entry = entries.find(entry => entry._id === this.entryId);
  },
};
</script>

<style lang="scss" scoped>
.gallery-item {
  &__photo {
    box-shadow: 8px 8px #000000;
  }
}
</style>
